<template>
    <main-layout>
        <template #header>
            <main-header :title="'Agent 버전 관리'">
            </main-header>
        </template>

        <template #toolbar>
            <div style="width: 500px">
                <search-bar
                        reactivity="input"
                        v-model="search" placeholder="검색"></search-bar>
            </div>
            <agent-file-upload-button :selected="selected">
            </agent-file-upload-button>
        </template>

        <template #body>
            <vue-data-table
                    :items="items"
                    :headers="headers"
                    :search="search"
            >
            </vue-data-table>
        </template>
    </main-layout>
</template>

<script>
    import MainLayout from "@/components/common/layout/MainLayout";
    import MainHeader from "@/components/common/layout/MainHeader";
    import SearchBar from "@/components/input/SearchBar";
    import {PATH} from "@/constants";
    import AgentFileUploadButton from "./part/AgentFileUploadButton";

    export default {
        name: "MonitoringManageVersion",
        components: {AgentFileUploadButton, SearchBar, MainHeader, MainLayout},
        data() {
            return {
                selected: [],
                search: "",
                items: [],
                headers: [
                    {
                        text: "버전",
                        value: "versionCode",
                        width: 200,
                    },
                    {
                        text: "버전명",
                        value: "versionName",
                        width: 500,
                    },
                    {
                        text: "타입",
                        value: "versionType",
                        width: 200,
                    },
                    {
                        text: "등록일자",
                        value: "regDatetime",
                        width: 200,
                    },
                ],
            }
        },
        created() {
            this.load();
        },
        methods: {
            async load() {
                const res = await this.$request(PATH.MONITORING.AGENT_VERSION)
                    .post()
                    .enqueue();
                this.items = res.data;
            },
        }
    }
</script>

<style scoped>

</style>